// extracted by mini-css-extract-plugin
export default {"loginWrapper":"LoginSignupHolder_loginWrapper__vrtK9","loginHolder":"LoginSignupHolder_loginHolder__-QjMy","contentHolder":"LoginSignupHolder_contentHolder__mmDB7"};